<template>
  <div class="checkTable">
    <div class="headLine">
      <img src="./leftAngle.png" alt="返回首页" @click="backIndex" />
      <div class="headTxt">查询最新调度页面数据</div>
    </div>

    <el-table
      :data="dataList"
      border
      lazy
      v-loading="dataListLoading"
      height="calc(100vh - 110px)"
      style="width: 100%"
    >
      <el-table-column
        prop="name"
        header-align="center"
        align="center"
        label="监测点"
      >
      </el-table-column>
      <el-table-column
        prop="time"
        header-align="center"
        align="center"
        width="100"
        label="最后刷新时间"
      >
        <template slot-scope="scope" v-if="scope.row.time">
          {{ scope.row.time.substr(0, 16) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="flowValue"
        header-align="center"
        align="center"
        label="瞬时流量"
      />
      <el-table-column
        prop="pressValue"
        header-align="center"
        align="center"
        label="压力"
      />
      <el-table-column
        prop="electricityState"
        header-align="center"
        align="center"
        label="电力状态">
        <template slot-scope="scope">
          <span style="color: #5daf34;font-weight: 600;" v-if="scope.row.electricityState === 1">市电</span>
          <span style="color: #f00;font-weight: 600;" v-else-if="scope.row.electricityState === 2 || scope.row.electricityState === 0">市电停电</span>
        </template>
      </el-table-column>
    </el-table>
<!--    <el-pagination-->
<!--      background-->
<!--      @size-change="sizeChangeHandle"-->
<!--      @current-change="currentChangeHandle"-->
<!--      :current-page="pageIndex"-->
<!--      :pager-count="pageCount"-->
<!--      :page-sizes="[10, 20, 50, 100]"-->
<!--      :page-size="pageSize"-->
<!--      :total="totalPage"-->
<!--      style="margin: 15px 0;text-align: center"-->
<!--      layout="prev, pager, next"-->
<!--    />-->
  </div>
</template>

<script>
import moment from "moment"
export default {
  data () {
    return {
      popstateLock: 0, //是否监听物理返回键
      dataForm: {
        startDate: moment(new Date()).startOf("month").format("YYYY-MM-DD"),
        endDate: moment(new Date()).format("YYYY-MM-DD")
      },
      pageCount: 5,
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      stationOptions: [],
      dataList: [], // 数据列表
      dataListLoading: false, // 数据加载
      loading: true
    }
  },
  watch:{
    popstateLock(val){
      //在父组件调用方法改变lock的值的时候控制路由的监听来避免preview的close路由调用
      if (val){
        this.addPopstate();
      }else{
        this.removePopstate();
      }
    }
  },
  created() {
    this.getDataList();
  },
  mounted () {
    this.addPopstate(); //在导航栏挂载的时候，对物理返回键进行监听
  },
  destroyed(){
    this.removePopstate();
  },
  methods: {
    addPopstate(){
      //判断是否H5路由
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新，并绑定getBack()来控制
        window.addEventListener('popstate', this.getBack, false);//false阻止默认事件
      }
    },
    removePopstate(){
      //解除监听
      window.removeEventListener('popstate', this.getBack, false);//false阻止默认事件
    },
    //指挥路由
    getBack() {
      //判断物理返回键是否监听
      if (!this.popstateLock) {
        window.history.pushState(null, null, '#')
      }
    },
    // 后面获取数据列表
    getDataList() {
      // 根据获取的数据请求符合条件的工单
      this.$http.httpGet('/app/stateData/latestList').then(res => {
        if (res.code === 0 && res.msg === 'success') {
          this.dataList = res.list;
        } else {
          this.$message.error('获取数据失败: ' + res.msg);
          this.dataList = [];
        }
      }).catch(() => {
      })

    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 返回首页
    backIndex() {
      this.$router.push({ name: 'Index' });
    }
  },

}
</script>

<style lang="scss">
.checkTable {
  position: relative;
  padding: 60px 10px 0;
  .headLine {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 998;
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    font-weight: 600;
    background-color: #409eff;
    color: #fff;
    text-align: center;
    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }
    .headTxt {
      font-size: 16px;
      line-height: 50px;
    }
  }
  .searchForm {
    position: relative;
    .el-form-item {
      margin: 0 0 10px;
      position: relative;
      overflow: hidden;
      .el-form-item__content {
        .fullList {
          width: 100% !important;
          margin: 0 0 10px;
        }
        .el-select {
          width: 75%;
          float: left;
        }
        .el-button {
          width: 22%;
          float: right;
        }
      }
    }
  }


  .tablePart {
    flex: 1;
    margin: 0 0 30px;
    border: 1px #ececec solid;
    .headLine {
      font-size: 18px;
      padding: 10px 0;
      border-bottom: 1px #ececec solid;
      text-align: center;
      font-weight: 600;
    }
    .headTilLine {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      overflow: hidden;
      .nameList {
        font-size: 14px;
        flex: 1;
        border-left: 1px #ececec solid;
        padding: 8px 5px;
        border-bottom: 1px #ececec solid;
        text-align: center;
        &:first-child {
          border-left: none;
        }
      }
    }

    .holdPart {
      position: relative;
      .pqBlock {
        position: relative;
        display: flex;
        flex-wrap: wrap;

        .firstName,
        .lastName {
          flex: 0 0 12.5%;
          align-items: center;
          justify-content: center;
          display: inline-flex;
          font-size: 14px;
          color: #000;
          font-weight: 600;
          border-bottom: 1px #ececec solid;
        }
        .lastName {
          border-left: 1px #ececec solid;
        }
        .rightName {
          position: relative;
          flex: 1;
          overflow: hidden;
          display: flex;
          flex-wrap: wrap;
          .pressList {
            position: relative;
            flex: 0 0 100%;
            display: flex;
            flex-wrap: wrap;
            overflow: hidden;
            .nameList {
              font-size: 14px;
              flex: 1;
              border-left: 1px #ececec solid;
              padding: 8px 5px;
              border-bottom: 1px #ececec solid;
              text-align: center;
            }
          }
        }
      }
    }

    .firstLine {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      overflow: hidden;
      .longValue,
      .normalValue {
        font-size: 14px;
        flex: 1;
        border-left: 1px #ececec solid;
        padding: 8px 5px;
        border-bottom: 1px #ececec solid;
        text-align: center;
      }
      .longValue {
        flex: 1.3;
        border-left: none;
      }
      &:last-child {
        .longValue,
        .normalValue {
          border-bottom: none;
        }
      }
    }
  }
}
</style>
